import { useEffect } from 'react';

export enum ScrollLockState {
  LOCK = 'LOCK',
  UNLOCK = 'UNLOCK',
}

const useBodyScrollLock = (state: ScrollLockState) => {
  useEffect(() => {
    if (state === ScrollLockState.LOCK) {
      document.body.style.overflow = 'hidden';
    } else if (state === ScrollLockState.UNLOCK) {
      document.body.style.overflow = 'auto';
    }
  }, [state]);
};

export default useBodyScrollLock;
